"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attach_to_element = exports.init = void 0;
function init(root) {
    if (root === void 0) { root = window.document.body; }
    var open_link_elements = root.querySelectorAll("[data-component=open-link]");
    for (var i = 0; i < open_link_elements.length; ++i) {
        var open_link_element = open_link_elements.item(i);
        if (!(open_link_element instanceof HTMLElement))
            continue;
        attach_to_element(open_link_element);
    }
}
exports.init = init;
function attach_to_element(open_link_element) {
    if (open_link_element.getAttribute('data-component') !== 'open-link')
        return;
    var href = open_link_element.getAttribute('data-href');
    if (!href)
        return;
    open_link_element.addEventListener('click', open_link_template_func(href));
}
exports.attach_to_element = attach_to_element;
function open_link_template_func(href) {
    return function () {
        window.location.href = href;
    };
}
